import {request, getDomain} from './backend'

const disableReferal = async id => {
  let {data} = await disableCode({
    id: id,
  })
  return data
}

const createReferal = async (name, code) => {
  let {data} = await issueCode({
    name: name,
    code: code,
  })
  return data
}

const getReferalCodes = async (page, pageSize, sortBy, text, code) => {
  let {data} = await referalCodes({
    sortBy: sortBy,
    page: page,
    pageSize: pageSize,
    text: text,
    code: code,
  })
  return data
}

const issueCode = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/acquisition/issue'

  let queryParameters = {}
  let form = {}

  return request(
    'post',
    domain + path,
    parameters,
    queryParameters,
    form,
    config,
  )
}

const disableCode = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/acquisition/disable'

  let queryParameters = {}
  let form = {}
  return request(
    'post',
    domain + path,
    parameters,
    queryParameters,
    form,
    config,
  )
}

const referalCodes = function(parameters = {}) {
  const domain = parameters.$domain ? parameters.$domain : getDomain()
  const config = parameters.$config
  let path = '/api/management/acquisition'
  let body
  let queryParameters = {}
  let form = {}
  if (parameters['page'] !== undefined) {
    queryParameters['Page'] = parameters['page']
  }
  if (parameters['pageSize'] !== undefined) {
    queryParameters['PageSize'] = parameters['pageSize']
  }
  if (parameters['sortBy'] !== undefined) {
    queryParameters['SortBy'] = parameters['sortBy']
  }
  if (parameters['text'] !== undefined) {
    queryParameters['Text'] = parameters['text']
  }
  if (parameters['code'] !== undefined) {
    queryParameters['Code'] = parameters['code']
  }
  if (parameters.$queryParameters) {
    Object.keys(parameters.$queryParameters).forEach(function(parameterName) {
      queryParameters[parameterName] =
        parameters.$queryParameters[parameterName]
    })
  }
  return request('get', domain + path, body, queryParameters, form, config)
}

export default {getReferalCodes, disableReferal, createReferal}
